// The calculator -> deck handoff: build the v3 value story and park it in localStorage under
// `clay-value-story-v1`, where the `/story` route reads it back through migrateDeckSnapshot. Same
// key as v2 (a v3 story is `v: 2`, so a stale v2 snapshot is told apart, not misread).

import type { CalculatorInput } from '../engine/use-case-engine';
import { STORY_KEY } from '../components/v3/deck/story-route-model';
import { storyForSizing, type StoryBuildOptions } from './save-request';

/** The slice of Storage this needs, so tests pass a stub. */
export type StoryStorage = Pick<Storage, 'setItem'>;

/** True when the story was written; false when storage is unavailable (private mode, quota). */
export function writeStoryForDeck(storage: StoryStorage, sizing: CalculatorInput, opts: StoryBuildOptions): boolean {
  try {
    storage.setItem(STORY_KEY, JSON.stringify(storyForSizing(sizing, opts)));
    return true;
  } catch {
    return false;
  }
}
